<template>
  <div class="container-fluid">
    <Card back>
      <template v-slot:header>
        <h5>
          <span> ارسال پیامک به &nbsp;&nbsp;| {{ PerName }} |</span> <i class="fad fa-sms float-left"></i> <span class="text-info">&nbsp;&nbsp;&nbsp;&nbsp; ({{ CustomerName }})</span>
        </h5>

        <hr />
      </template>
      <template v-slot:content>
        <div class="container mt-3">
          <div class="row">
            <div class="col-lg-8 col-12">
              <textarea v-model="DataAxiosSend.ArryfildValue.ListDataCRM[0].Txt" class="form-control" rows="8" placeholder="متن پیامک"></textarea>
            </div>
            <div class="col-lg-4 col-12 text-center">
              <h5>شماره همراه: &nbsp; {{ PerMobile }}</h5>
              تاریخ: &nbsp; {{ $store.state.JalaliDate }}
              <h6>کاربر اسال کننده: &nbsp; {{ $session.get('UserInfo').namFam }}</h6>
              <select class="form-control mt-5 text-center" @change="ParamsSelected($event)">
                <option :value="-1">-- پارامتر های آماده انتخاب کنید --</option>
                <option v-for="(item, key) in Rows" :key="key" :value="item.MatnSms">
                  {{ item.Onvan }}
                </option>
              </select>
              <button class="btn btn-success w-100 mt-2" @click="SendSms">ارسال پیامــک <i class="fad fa-paper-plane"></i></button>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'

export default {
  props: ['PerMobile', 'PerName', 'PerId', 'CustomerId', 'CustomerName', 'personel'],
  data() {
    return {
      title: 'ارسال پیامک',
      DataAxiosSend: {
        Action: 'Sms/SendSms',
        Method: 'POST',
        ArryfildValue: {
          ListDataCRM: [
            {
              tblPersonelId: this.PerId,
              tblCustomerId: this.CustomerId,
              Txt: '',
              PhoneNUm: this.PerMobile,
              tblUserGrpInsert: this.$session.get('UserInfo').tblUserGrpId,
              tblUserid: this.$session.get('UserInfo').tblUserId,

              CustomerName: '',
              CustomerCode: 0,
              CodeBazaryabi: 0,
              FullName: '',
              PerMobile: '',
              UserName: '',
              Pss: '',
              UserMobile: '',
              PssIsEncrypt: true,
            },
          ],
        },
      },
      Rows: [],
    }
  },
  components: { Card },
  methods: {
    SendSms() {
      // console.log(this.personel)
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].CustomerName = this.$store.state.Customer.Customer.CustomerName
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].CustomerCode = this.$store.state.Customer.Customer.CustomerCode
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].CodeBazaryabi = this.$store.state.Customer.Customer.CodeBazaryabi
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].FullName = this.personel.FullName
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].PerMobile = this.personel.PerMobile
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].UserName = this.personel.UserName
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].Pss = this.personel.Pss
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].TblPersonalId = this.personel.Id
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].UserMobile = this.personel.UserMobile
      this.$PostData(this.DataAxiosSend).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('عملیات موفق', 'پیامک با موفقیت برای کاربر ارسال شد', 'success', 2000)
          // if ((this.CustomerId = 999)) {
          //   this.$router.push({ name: 'TarifKarbaran' })
          // } else {
          // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.CustomerId } })
          this.$FindeCustomerById('DetailCustomer',this.CustomerId,false,null)
          // }
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ارسال پیامک بوجود آمده است دوباره تلاش کنید', 'error', 2000)
        }
      })
    },
    GetRows() {
      let DataAxiosSearch = { ArryfildValue: { ShobeId: 1, SoftwareId: 2 } }
      DataAxiosSearch.Action = 'SmsTemplate/GetSmsTemplateInCRM'
      DataAxiosSearch.Method = 'post'
      this.$PostData(DataAxiosSearch)
        .then((result) => {
          if (result.Status == 'Ok') {
            this.Rows = result.Data
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    ParamsSelected(e) {
      this.DataAxiosSend.ArryfildValue.ListDataCRM[0].Txt = e.target.value
    },
  },
  mounted() {
    this.$store.state.CustomerId = this.CustomerId
    this.GetRows()
  },
}
</script>
